const TOGGLE_MILESTONE_TRACKER_VIEW = "TOGGLE_MILESTONE_TRACKER_VIEW";

export default {
  TOGGLE_MILESTONE_TRACKER_VIEW,
};
